import { useState, useEffect, useCallback } from "react";
import { createContainer } from "unstated-next";

import { Provider } from "../../interfaces/admin/provider.interface";
import { fetchProviders } from "../../../api/admin/content-providers/endpoints-referrers";
import { FirebaseAuthContainer } from "../auth/firebase-auth-container.util";
import { isAdminPanel } from "../../utilities/routes/routes.util";

function useProviders() {
    const { user } = FirebaseAuthContainer.useContainer();
    const [providers, setProviders] = useState<Provider[]>([]);

    const loadProviders = useCallback(() => {
        if (!isAdminPanel || !user) return;

        fetchProviders(user.companyId).then(response => {
            setProviders(response.data);
        });
    }, [user]);

    useEffect(() => {
        loadProviders();
    }, [loadProviders]);

    return {
        providers,
        loadProviders
    };
}

export const ProvidersContainer = createContainer(useProviders);
